import { Select } from '@cian/ui-kit';
import * as React from 'react';
import { INewbuildingSectionProps } from '../../utils/types';
import * as styles from '../AreaInput/styles.css';
import { ErrorPopover } from '../ErrorPopover';

export const SectionSelector: React.FC<INewbuildingSectionProps> = props => {
  const { selectedSection, newbuildingSections, onItemChange, errorMessage } = props;

  return (
    <div className={styles['container-mobile']}>
      <ErrorPopover tooltipContent={errorMessage}>
        <Select size="M" value={selectedSection} options={newbuildingSections} onChange={onItemChange} />
      </ErrorPopover>
    </div>
  );
};
